<form name="StateHolidayForm" (ngSubmit)="SaveStateHoliday()" #StateHolidayForm="ngForm">
    <div class="pt-1">
        <div class="card">
            <div class="card-header">
                <div class="card-title">State Holiday Mapping</div>
            </div>

            <div class="card-body">
                <form name="StateHolidayFilterForm" (ngSubmit)="Validate(StateHolidayFilterForm)"
                    #StateHolidayFilterForm="ngForm" class="pb-2">
                    <div class="row">
                        <div class="col-md-2  px-1">
                            <label>Year</label>
                            <select name="Year" class="form-control form-select" [(ngModel)]="filter.Year"
                                #Year="ngModel" (ngModelChange)="ClearHolidays()" title="Select Year" required
                                [disabled]="DisablesFilter.Year">
                                <option [value]=null disabled hidden>Select Year</option>
                                <option *ngFor="let Year of Years" [value]="Year">
                                    {{Year}}
                                </option>
                            </select>
                            <div class="invalid-feedback">
                                Please select year!
                            </div>
                        </div>
                        <div class="col-md-5  px-1">
                            <label>State</label>
                            <ng-select name="StateId" (change)="ClearHolidays()" [(ngModel)]="filter.StateId"
                                #StateId="ngModel" required [disabled]="DisablesFilter.Year" placeholder="Select State">
                                <ng-option *ngFor="let State of StatesFilter"
                                    [value]="State.StateMasterID">{{State.StateName}}</ng-option>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select state!
                            </div>
                        </div>
                        <div class="col-md-1 px-1 pt-4">
                            <button type="submit" class="btn btn-primary text-nowrap" [disabled]="isDisabled">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Get Holiday':'Loading...'}}</button>
                        </div>
                    </div>
                </form>

                <div class="row" [ngClass]="{'display': isDisabledTable}">

                    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th>Holiday Name</th>
                                <th style="width: 150px">Date</th>
                                <th style="width: 250px;">Not Applicable/Compulsory/Optional</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let element of StateHolidayData">

                                <td>{{element.HolidayName}}</td>
                                <td style="width: 150px">{{element.Date}}</td>
                                <td style="width: 250px;">

                                    <select name="TypesOfLeave_{{element.ESS_CompanyHolidayMasterId}}"
                                        [(ngModel)]="element.TypesOfLeave" required>
                                        <option *ngFor="let type of TypesOfLeaves" [value]="type">
                                            {{type}}
                                        </option>
                                    </select>
                                </td>

                            </tr>
                        </tbody>

                    </table>

                </div>
            </div>
            <div class="card-footer">
                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                        (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Cancel':'Loading...'}}</button>

                    <button
                        *ngIf="(this.filter.StateId == 0 && this.common.PageRight.IsAdd) || (this.filter.StateId > 0 && this.common.PageRight.IsEdit)"
                        type="submit" class="btn btn-primary text-nowrap" [disabled]="isDisabled"><i class="bi bi-save"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </div>
</form>